import { AfterViewInit, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { swiperGrid2Config, swiperGrid3Config } from "../../shared/utility/config";
import { environment } from '../../../environments/environment';
import { EmitterService } from '../../services/emitter.service';
import { Router } from '@angular/router';
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import * as $ from 'jquery';
import Swiper, { Navigation } from 'swiper';


@Component({
  selector: 'app-game-providers',
  templateUrl: './game-providers.component.html',
  styleUrls: ['./game-providers.component.scss'],
  encapsulation:ViewEncapsulation.None
})
export class GameProvidersComponent implements AfterViewInit ,OnDestroy {
  langCode;
  destroy$: Subject<boolean> = new Subject<boolean>();
  @Input() gameProviderMap;
  @Input() allProvidersPage;
  siteUrlPath: string = environment.siteUrl;
  mediaUrlPath = environment.koiMediaPath;
  swiperDefaultConfig = swiperGrid2Config;
  swiperColumnConfig = swiperGrid3Config;
  swiperButtonsCheck = false;
  @Input() providerGroupName;
  providerGroupNameString;

  constructor(
    private emitterService: EmitterService,
    private router: Router
  ) {
    this.langCode = localStorage.getItem('langCode')
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(langCode=>{
      this.langCode = langCode;
    });
  }

  ngAfterViewInit(): void {
    if(!this.allProvidersPage) {
      this.initializeSwiper();
      setTimeout(() => {
        this.swiperButtonsCheck = true;
      });
    }
  }

  goToProviderGames(providerId) {
    this.router.navigate([this.langCode + '/casino/allgames'], { queryParams: { "providerId": providerId } });
  }

  initializeSwiper() {
    this.providerGroupNameString = (this.providerGroupName.replace(/[\s~`!@#$%^&*()_+\-={[}\]|\\:;"'<,>.?/]+/g, '_')).toLowerCase();
    setTimeout(() => {
      new Swiper(('.lobby_game--providers--'+ this.providerGroupNameString), {
        modules: [Navigation],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 12,
        freeMode: true,
        navigation: {
          prevEl: ".lobby_game--providers-prev--"+ this.providerGroupNameString,
          nextEl: ".lobby_game--providers-next--"+ this.providerGroupNameString
        },
        breakpoints: {
          0: {
            slidesPerView: 2.05,
            slidesPerGroup: 2,
            spaceBetween: 12
          },
          481: {
            slidesPerView: 2.05,
            slidesPerGroup: 2,
            spaceBetween: 12
          },
          768: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 12
          },
          992: {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 18,
          },
          1024:{
            slidesPerView: 6,
            spaceBetween: 18,
          }
        }
      });
    });
  }

  isToShowButtons() {
    if(this.swiperButtonsCheck) {
      if (!($(".lobby-header--providers--"+this.providerGroupNameString +" .swiper-button-prev").hasClass("swiper-button-disabled") && $(".lobby-header--providers--"+this.providerGroupNameString +" .swiper-button-next").hasClass("swiper-button-disabled"))) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
